import './index.less';

import classNames from 'classnames';
import React, { ReactNode } from 'react';

import Ready from '@/assets/icon/account/ready.svg';
import UnReady from '@/assets/icon/account/unReady.svg';

import AccountSecurityIcon from './headerIcon';

interface IProps {
  className?: string;
  icon: string;
  text: string;
  subText?: ReactNode;
  operation?: ReactNode;
  status?: boolean;
  statusNode?: ReactNode;
  showStatusIcon?: boolean;
  molyIcon?: ReactNode;
}

const index: React.FC<IProps> = ({
  icon,
  molyIcon,
  text,
  subText,
  status,
  statusNode,
  operation,
  className,
  showStatusIcon = true,
}) => {
  return (
    <div className={classNames('account-basic', className)}>
      <AccountSecurityIcon type={icon} molyIcon={molyIcon} />
      <div className="account-basic-info">
        <div
          className={classNames('account-basic-title', {
            'account-basic-title-full': !subText,
          })}
        >
          {text}
        </div>
        {subText && <div className="account-basic-desc">{subText}</div>}
      </div>
      {status !== undefined && (
        <div
          className={classNames('account-status', {
            'account-status-ready': status,
            'account-status-unready': !status,
          })}
        >
          {showStatusIcon && (
            <img
              src={status ? Ready : UnReady}
              alt="ready"
              className="status-ready-img"
            />
          )}
          {statusNode}
        </div>
      )}

      <div className="account-operation">{operation}</div>
    </div>
  );
};

export default index;
